import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const BannerRequestForm = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const getBannerContent = () => {
    switch (location.pathname) {
      case '/partnership':
        return {
          title: t('partnership.title'),
          subtitle: t('partnership.subtitle'),
          backgroundImage: 'https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?q=80&w=2940&auto=format&fit=crop'
        };
      case '/contact':
        return {
          title: t('requestForm.title'),
          subtitle: t('requestForm.subtitle'),
          backgroundImage: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?q=80&w=2940&auto=format&fit=crop'
        };
      default:
        return {
          title: t('requestForm.title'),
          subtitle: t('requestForm.subtitle'),
          backgroundImage: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?q=80&w=2940&auto=format&fit=crop'
        };
    }
  };

  const bannerContent = getBannerContent();

  return (
    <div className="banner-request-wrapper">
      <div className="banner-request">
        <div className="banner-overlay"></div>
        <Container className="h-100">
          <Row className="h-100 align-items-center">
            <Col lg={8} md={10} className="mx-auto text-center">
              <div className="banner-content">
                <h1 className="banner-title">{bannerContent.title}</h1>
                <div className="title-separator">
                  <span className="separator-line"></span>
                  <span className="separator-icon">
                    <i className="fas fa-paper-plane"></i>
                  </span>
                  <span className="separator-line"></span>
                </div>
                <p className="banner-subtitle">{bannerContent.subtitle}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <style jsx="true">{`
        .banner-request-wrapper {
          position: relative;
          height: 400px;
          overflow: hidden;
          background-color: #000;
        }
        
        .banner-request {
          width: 100%;
          height: 100%;
          position: relative;
          background-image: url('${bannerContent.backgroundImage}');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }
        
        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(to right, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 100%);
        }
        
        .banner-content {
          position: relative;
          z-index: 2;
          padding: 2rem;
          color: #fff;
        }
        
        .banner-title {
          font-size: 3.5rem;
          font-weight: 700;
          letter-spacing: 1px;
          margin-bottom: 1.5rem;
          text-transform: capitalize;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }
        
        .title-separator {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }
        
        .separator-line {
          width: 60px;
          height: 1px;
          background-color: rgba(255, 255, 255, 0.7);
        }
        
        .separator-icon {
          margin: 0 15px;
          color: #fff;
          font-size: 1.2rem;
          transform: rotate(25deg);
        }
        
        .banner-subtitle {
          font-size: 1.2rem;
          font-weight: 300;
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }
        
        @media (max-width: 991.98px) {
          .banner-request-wrapper {
            height: 350px;
          }
          
          .banner-title {
            font-size: 2.8rem;
          }
        }
        
        @media (max-width: 767.98px) {
          .banner-request-wrapper {
            height: 300px;
          }
          
          .banner-title {
            font-size: 2.2rem;
          }
          
          .banner-subtitle {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default BannerRequestForm; 